import { render, staticRenderFns } from "./myShop.vue?vue&type=template&id=8e8c9e3a&"
import script from "./myShop.vue?vue&type=script&lang=js&"
export * from "./myShop.vue?vue&type=script&lang=js&"
import style0 from "./myShop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports